import React, { useEffect, useRef } from 'react';

const AudioPlayer = ({ src, startTime, endTime, autoPlay, onTimeUpdate, seekKey }) => {
  const audioRef = useRef(null);

  useEffect(() => {
    if (audioRef.current && startTime !== null && startTime !== undefined) {
      audioRef.current.currentTime = startTime;
      if (autoPlay) {
        audioRef.current.play().catch((err) => console.warn('Autoplay failed', err));
      }
    }
  }, [startTime, autoPlay, seekKey]);

  const handleTimeUpdate = (event) => {
    const current = event.target.currentTime;
    if (typeof endTime === 'number' && current >= endTime) {
      event.target.pause();
    }
    onTimeUpdate?.(current);
  };

  return (
    <div className="fixed bottom-0 left-0 right-0 bg-white border-t border-gray-200 p-3 shadow-lg z-40">
      <div className="max-w-7xl mx-auto flex items-center gap-4">
        <audio
          ref={audioRef}
          controls
          src={src}
          className="w-full"
          onTimeUpdate={handleTimeUpdate}
        />
      </div>
    </div>
  );
};

export default AudioPlayer;
